// Deprecated file. Will be removed in version 2.x.
export { default as default } from './PhoneInputReactResponsiveUI'